import { render, staticRenderFns } from "./CalidadMecanizadoTab.vue?vue&type=template&id=2c25ba60&"
import script from "./CalidadMecanizadoTab.vue?vue&type=script&lang=js&"
export * from "./CalidadMecanizadoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports